import React from "react";
import HeaderOne from "../common/header/Header";
import HeroOne from "../components/hero/Hero";
import TeamOne from "../components/team/TeamBrief";
import Footer from "../common/footer/Footer";
import HomeExtras from "../components/extras/HomeExtras";
import DonateCta from "../components/cta/DonateCta";
import SEO from "../common/seo/SEO";

const Home = () => {
  return (
    <>
      <SEO />
      <HeaderOne />
      <HeroOne />
      <HomeExtras />
      <TeamOne />
      <DonateCta />
      <Footer />
    </>
  );
};

export default Home;
